// extracted by mini-css-extract-plugin
export var brand = "_1y-9";
export var button = "_1y-0";
export var chevron = "_1y-v";
export var chevronButton = "_1y-w";
export var content = "_1y-n";
export var danger = "_1y-g";
export var dangerOutlined = "_1y-h";
export var dark = "_1y-l";
export var darkTheme = "_1y-c";
export var extraSmall = "_1y-4";
export var fullWidth = "_1y-8";
export var ghost = "_1y-d";
export var gray = "_1y-t";
export var icon = "_1y-p";
export var iconButton = "_1y-s";
export var iconButtonBorder = "_1y-x";
export var iconButtonBorderDark = "_1y-y";
export var iconButtonBorderLight = "_1y-z";
export var iconLeft = "_1y-q";
export var iconRight = "_1y-r";
export var large = "_1y-1";
export var light = "_1y-m";
export var medium = "_1y-2";
export var micro = "_1y-5";
export var nano = "_1y-7";
export var outlined = "_1y-k";
export var pending = "_1y-a";
export var primary = "_1y-i";
export var shadow = "_1y-o";
export var small = "_1y-3";
export var solidLight = "_1y-e";
export var solidLightBrand = "_1y-f";
export var spinner = "_1y-u";
export var transparent = "_1y-j";
export var warning = "_1y-b";
export var wideNano = "_1y-6";